<template>
  <b-modal
    v-model="isShow"
    :title="stepTitle"
    centered
    hide-footer
    no-close-on-backdrop
    @hide="onHide"
  >
    <!-- Custom close button via header-close slot is default in b-modal -->
    <StepSignature
      v-if="currentStep === 1"
      :id="id"
      :token="token"
      :updateShowLoading="updateShowLoading"
      @signature="changeSignature"
      @next-step="nextStep"
    />
    <StepSelectOtp
      v-else-if="currentStep === 2"
      :mobile="mobile"
      :id="id"
      :email="email"
      :token="token"
      :updateShowLoading="updateShowLoading"
      @method="changeMethod"
      @next-step="nextStep"
    />
    <StepOtp
      v-else-if="currentStep === 3"
      :id="id"
      :mobile="mobile"
      :method="method"
      :token="token"
      :updateShowLoading="updateShowLoading"
      :signature="signature"
      @next-step="nextStep"
      @prev-step="prevStep"
    />
    <StepSuccess v-else-if="currentStep === 4" @close="hide" />

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="false" />
  </b-modal>
</template>

<script>
  import StepSignature from './components/StepSignature.vue'
  import StepSelectOtp from './components/StepSelectOtp.vue'
  import StepOtp from './components/StepOtp.vue'
  import StepSuccess from './components/StepSuccess.vue'

  const STEP_TITLES = {
    1: 'KÝ XÁC NHẬN',
    2: 'XÁC THỰC BẢO MẬT',
    3: 'XÁC THỰC BẢO MẬT',
    4: 'HỢP ĐỒNG ĐÃ XÁC NHẬN',
  }

  export default {
    name: 'PopupConfirmNganLuong',
    components: {
      StepSignature,
      StepSelectOtp,
      StepOtp,
      StepSuccess,
    },
    props: {
      token: { type: String, required: true },
      id: { type: String, required: true },
      email: { type: String, required: true },
      mobile: { type: String, required: true },
    },
    data() {
      return {
        isShow: false,
        currentStep: 1,
        showLoading: false,
        method: '',
        signature: '',
      }
    },
    computed: {
      stepTitle() {
        return STEP_TITLES[this.currentStep] || ''
      },
    },
    methods: {
      show() {
        // this.currentStep = 2 // used for test
        this.isShow = true
      },
      hide() {
        this.isShow = false
      },
      onHide() {
        this.$emit('hide', this.currentStep === 4)
      },
      changeSignature(signature) {
        this.signature = signature
      },
      nextStep() {
        this.currentStep++
      },
      prevStep() {
        this.currentStep--
      },
      changeMethod(method) {
        this.method = method
      },
      updateShowLoading(value) {
        this.showLoading = value
      },
    },
  }
</script>

<style>
  /* @import '~@/assets/css/nganluong.css'; */
</style>
